"use strict";

PF.Popup.Tooltip = class PopupTooltip extends Platform.Popup
	{
	static get options()
		{
		return {
			positionTrait: PF.Popup.Tooltip.Position,
			expandWidth: 0
		};
		}

	init()
		{
		super.init();
		}

	createDom()
		{
		super.createDom();
		this.css = {};

		this.dom.popup.addClass('pf-tooltip');
		}

	open()
		{
		if (this.state === 'close')
			{
			super.open();
			this.dom.clone = new PF.Dom.Node('<div>&nbsp;</div>');
			this.dom.anchor.before(this.dom.clone);

			this.dom.clone.width(this.dom.anchor.outerWidth(true));
			this.dom.clone.height(this.dom.anchor.outerHeight(true));
			this.css.width = this.dom.anchor.width() + this.expandWidth;
			this.css.height = this.dom.anchor.height();
			this.css.marginTop = this.dom.anchor.css('margin-top');
			this.css.marginLeft = this.dom.anchor.css('margin-left');

			this.dom.clone.css('display', this.dom.anchor.css('display'));
			this.dom.popup.append(this.dom.anchor);
			this.dom.anchor.addClass('pf-anchor');

			this.dom.anchor.css({top: this.dom.clone.offset().top + this.css.marginTop});
			this.dom.anchor.css({left: this.dom.clone.offset().left + this.css.marginLeft});
			this.dom.anchor.css({width: this.css.width});
			// this.dom.anchor.css({height: this.css.height});
			this.heightObserver = new PF.HeightObserver(this.dom.anchor, () => {
				this.setPosition( [],  null, true);
			});
			this.heightObserver.start();
			this.renderSatus = true;
			}
		}

	close()
		{
		if (this.state === 'open' || this.state === 'init')
			{
			super.close();

			if (this.renderSatus === true)
				{
				this.dom.clone.after(this.dom.anchor);
				// this.dom.clone.hide();
				this.dom.clone.remove();

				this.dom.anchor.node.setAttribute('style', '');
				this.dom.anchor.removeClass('pf-anchor');
				}
			}
		}


	};

Platform.Popup.Tooltip.Position = class Platform_Popup_Tooltip_Position extends Platform.Popup.Position
	{
	setPosition(mutations = [], observer = null, forse = false)
		{
		if (!this.isSetNeed(forse))
			{
			return;
			}

		// this.dom.clone.after(this.dom.anchor);
		// this.dom.clone.hide();
		// this.dom.anchor.attr('style', '');
		// this.dom.anchor.removeClass('pf-anchor');

		// this.dom.clone.width(this.dom.anchor.outerWidth(true));
		// this.dom.clone.height(this.dom.anchor.outerHeight(true));
		// this.css.width = this.dom.anchor.width();
		// this.css.height = this.dom.anchor.height();
		//
		// this.dom.clone.css('display', this.dom.anchor.css('display'));
		// this.dom.popup.append(this.dom.anchor);
		// this.dom.anchor.addClass('pf-anchor');
		//
		// this.dom.anchor.css({top: this.dom.clone.offset().top});
		// this.dom.anchor.css({left: this.dom.clone.offset().left});
		// this.dom.anchor.css({width: this.css.width});
		// this.dom.anchor.css({height: this.css.height});

		super.setPosition(mutations, observer, forse);
		}

	check(p)
		{
		let minTop = p.top;
		let minLeft = p.left;
		minTop = Math.min(minTop, this.dom.anchor.offset().top);
		minLeft = Math.min(minLeft, this.dom.anchor.offset().left);

		let maxTop = p.top + this.dom.container.outerHeight(true) + this.windowIndent;
		let maxLeft = p.left + this.dom.container.outerWidth(true) + this.windowIndent;
		maxTop = Math.max(maxTop, this.dom.anchor.offset().top + this.dom.anchor.outerHeight(true) + this.windowIndent);
		maxLeft = Math.max(maxLeft, this.dom.anchor.offset().left + this.dom.anchor.outerWidth(true) + this.windowIndent);
		let body = PF.Dom.Node.findOne('body');
		return this.windowIndent <= minTop && maxTop < body.height()
			&& this.windowIndent <= minLeft && maxLeft < body.width();
		}

	toCenter()
		{
		let body = PF.Dom.Node.findOne('body');
		this.dom.anchor.css({top: this.windowIndent});
		this.dom.anchor.css({left: body.width() / 2 - this.dom.anchor.width() / 2});

		return this.calculate([1, 50], [1, -50], [this.dom.anchor.height(), 0], this.dom.popupContainer);
		}

	};